/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// import { pxToEm, disable, mediaQuery } from '@insticator/insticator-ui'; // iui-utils



/* ++++++++++ --------------- EXPORTS : ACCOUNT SELECT PAYMENT METHOD : STYLES --------------- ++++++++++ */
export default theme =>({
    selectmethod: {
    }
});
